import {inject, Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {BooxSessionService, BooxStorageService} from '../service';
import {BOOX_ROUTES, BooxRoutesToken} from '../token';


@Injectable({
  providedIn: 'root'
})
export class BooxSessionGuard implements CanActivate, CanActivateChild {

  private readonly router = inject(Router);
  private readonly sessionSrv = inject(BooxSessionService);
  private readonly storageSrv = inject(BooxStorageService);
  private readonly routes = inject(BOOX_ROUTES);


  private handle(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

    if (this.sessionSrv.isAuthenticated) return true;

    const {url} = state;
    this.storageSrv.setItem('redirectUrl', url);
    console.log(this.storageSrv.getItem('redirectUrl'));

    if (!this.routes?.sign_in?.length) {
      console.error(`Has no sign-in route.`);
      return false;
    }

    return this.router.createUrlTree(this.routes.sign_in);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(route, state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(childRoute, state);
  }
}
